

// const API_URL = 'http://127.0.0.1:8000/api';
// const API_URL = 'https://pomosty1.pl/api';
const API_URL = 'https://paw-stege.de/api';


export default function useActions() {

  async function getCategories() {
    return fetch(`${API_URL}/platform-product-categories`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then(res => res.json())
  }

  async function addOrder(order) {
    return fetch(`${API_URL}/platform-order`, {
      method: 'post',
      // mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(order),
    })
      .then(res => res.json())
  }

  return {
    getCategories,
    addOrder,
  };
}
